import { render, staticRenderFns } from "./otherType.vue?vue&type=template&id=d32a0de4&"
import script from "./otherType.vue?vue&type=script&lang=js&"
export * from "./otherType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports